export const instagramLinkDomens = ['instagram.com', 'www.instagram.com'];

export const facebookLinkDomens = ['facebook.com', 'www.facebook.com'];
